import React from 'react'
import { comma, removeComma, getTime, TextAreas } from '../../../service/project'
import Downloadfile from '../../../service/components/Downfile'
import { STEP } from '../projectStepManager'
import ProjectHeader from './ProjectHeader'

function ProjectInfoView(props) {
    var pg = props.pg
    var fine = props.fine
    var displayStep = props.displayStep
    var admin = props.admin
    var lastOffer = props.lastOffer

    if (!pg) {
        return null
    }

    return (
        <>
            {/* <div className="pgbox_top flex j a mb20 ">
                <h1 className="pgT mb0 w100 mt10">
                    <span className="mr10 gbox_hover">{fine ? '프로젝트 등록' : displayStep}</span>
                    {pg.title}
                </h1>
                <div className="flex j a w50">
                    <div className="flex"></div>
                    <div>
                        <div className="updatetimes">등록일 : {fine ? getTime() : pg.createdtime}</div>
                        {!fine ? <div className="updatetimes">수정일 : {fine ? getTime() : pg.updatetime}</div> : null}
                    </div>
                </div>
            </div> */}
            {/* <ProjectHeader pg={pg} viewTitle="프로젝트 등록" /> */}
            {/* <ProjectHeader pg={pg} viewTitle="프로젝트 등록" /> */}
            <ProjectHeader pg={pg} viewTitle={displayStep === STEP.TEMP ? '임시저장' : '프로젝트 등록'} />

            {/* <div className="flex subcatebox a">
                <span className="mr10 catebox w_round_tag_cateBox fontWb">{pg.cateother ? pg.cateother : pg.cate}</span>
                <div className="crossline"></div>
                <ul className="flex ml10 w_round_tag_c fontWb">
                    {pg.minicateother ? (
                        <>
                            {pg.minicate.map(function (value) {
                                return <li key={value}>{value}</li>
                            })}
                            <li>{pg.minicateother}</li>
                        </>
                    ) : (
                        pg.minicate.map(function (value) {
                            return (
                                <li key={value} className="mr20">
                                    {value}
                                </li>
                            )
                        })
                    )}
                </ul>
            </div> */}

            <div className="table_container flex j">
                <div className="flex w100">
                    <ul className="w50 mr10">
                        <li className="flex">
                            <div className="flex j mr10">
                                <span className="table_label bold w110 mr10">1. 희망 금액 </span>
                                <span>:</span>
                            </div>
                            <span className="flex j a w100">
                                {comma(Number(removeComma(pg.price)) + Number(removeComma(pg.price) * 0.1))}원
                                {admin && lastOffer ? (
                                    <span className="ml10 priceTag">
                                        {lastOffer.num === 1 || 3 ? '최종 금액 : ' : '수정 금액 : '}
                                        {comma(
                                            Number(removeComma(lastOffer.price)) +
                                                Number(removeComma(lastOffer.price) * 0.1),
                                        )}
                                        원
                                    </span>
                                ) : null}
                            </span>
                        </li>

                        <li className="flex">
                            <div className="flex j mr10">
                                <span className="table_label bold w110 mr10">2. 예상 기간 </span>
                                <span>:</span>
                            </div>
                            <span className="flex j a w100">
                                {pg.term}일
                                {admin && lastOffer ? (
                                    <span className="ml10 priceTag">
                                        {lastOffer.num === 1 || 3 ? '최종 기간 : ' : '수정 기간 : '}
                                        {lastOffer.term} 일
                                    </span>
                                ) : null}
                            </span>
                        </li>

                        <li className="flex">
                            <div className="flex j mr10">
                                <span className="table_label bold w110 mr10">3. 파트너 조건 </span>
                                <span>:</span>
                            </div>
                            <span className="listwrap">
                                {pg.conditions.map(function (value) {
                                    return (
                                        <div className="list" key={value}>
                                            <span className="comma">,</span>
                                            <span className="mr5">{value}</span>
                                        </div>
                                    )
                                })}
                            </span>
                        </li>

                        <li className="flex">
                            <div className="flex j mr10">
                                <span className="table_label bold w110 mr10">4. 시작 일자 </span>
                                <span>:</span>
                            </div>
                            <span>{pg.startdate}</span>
                        </li>

                        <li className="flex">
                            <div className="flex j mr10">
                                <span className="table_label bold w110 mr10">5. 진행 상태 </span>
                                <span>:</span>
                            </div>
                            <span>
                                {pg.pStatus === 'new'
                                    ? '신규로 진행합니다'
                                    : pg.pStatus === 'better'
                                    ? '기존 진행했던 프로젝트의 개선'
                                    : pg.pStatus === 'ing'
                                    ? '기존 진행했던 프로젝트의 유지보수'
                                    : ''}
                            </span>
                        </li>
                    </ul>

                    <ul className="w50">
                        <li className="flex">
                            <div className="flex j mr10">
                                <span className="table_label bold w110 mr10">6. 담당자 </span>
                                <span>:</span>
                            </div>
                            <span>
                                {pg.client} ({pg.company})
                            </span>
                        </li>

                        <li className="flex">
                            <div className="flex j mr10">
                                <span className="table_label bold w110 mr10">7. 이메일 </span>
                                <span>:</span>
                            </div>
                            <span>{pg.email}</span>
                        </li>

                        <li className="flex">
                            <div className="flex j mr10">
                                <span className="table_label bold w110 mr10">8. 주소지 </span>
                                <span>:</span>
                            </div>
                            <span>{pg.clientaddress}</span>
                        </li>

                        <li className="flex">
                            <div className="flex j mr10">
                                <span className="table_label bold w110 mr10">9. 연락처 </span>
                                <span>:</span>
                            </div>
                            <span>{pg.clientphone}</span>
                        </li>

                        <li className="flex">
                            <div className="flex j mr10">
                                <span className="table_label bold w110 mr10">10. 회의 방식 </span>
                                <span>:</span>
                            </div>
                            <h1>
                                {pg.meet === 'on'
                                    ? '온라인'
                                    : pg.meet === 'off'
                                    ? '오프라인'
                                    : pg.meet === 'onoff'
                                    ? '온오프라인'
                                    : ''}
                            </h1>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="pgbody">
                <div className="pgboxs">
                    <span className="name_subtitle f20">11. 프로젝트 개요 </span>
                    <h2>
                        <TextAreas value={pg.outline} />
                    </h2>
                </div>

                <div className="pgboxs">
                    <span className="name_subtitle bold f20">12. 개발 핵심 기술</span>
                    <h2>{pg.needskill}</h2>
                </div>

                <div className="pgboxs">
                    <span className="name_subtitle bold f20">13. 최종 산출물 </span>
                    <h2>
                        <TextAreas value={pg.lastprojects} />
                    </h2>
                </div>

                <div className="pgboxs">
                    <span className="name_subtitle bold f20">14. 프로젝트 상세 설명</span>
                    <h2>
                        <TextAreas value={pg.projects} />
                    </h2>
                </div>

                <div className="pgboxs">
                    <span className="name_subtitle bold f20">15. 프로젝트 관련 파일</span>
                    <ul className="list mt20">{pg.files ? <Downloadfile lists={pg.files} type={'multi'} /> : ''}</ul>
                </div>

                {displayStep === STEP.REGISTER && admin ? <div className="mt40 flex j c"></div> : ''}
            </div>
        </>
    )
}

export default ProjectInfoView
